import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env';
import { UserBeautybookPostComponent } from './pages/user-beautybook-post/user-beautybook-post.component';
import { UserCheckoutComponent } from './pages/user-checkout/user-checkout.component';
import { UserDashboardComponent } from './pages/user-dashboard/user-dashboard.component';
import { UserHappyPayBankAccountComponent } from './pages/user-happy-pay/user-happy-pay-bank-account/user-happy-pay-bank-account.component';
import { UserHappyPayTopupComponent } from './pages/user-happy-pay/user-happy-pay-topup/user-happy-pay-topup.component';
import { UserHappyPayTransactionHistoryComponent } from './pages/user-happy-pay/user-happy-pay-transaction-history/user-happy-pay-transaction-history.component';
import { UserHappyPayWithdrawalComponent } from './pages/user-happy-pay/user-happy-pay-withdrawal/user-happy-pay-withdrawal.component';
import { UserHappyPayComponent } from './pages/user-happy-pay/user-happy-pay.component';
import { UserInvoiceComponent } from './pages/user-invoice/user-invoice.component';
import { UserOrderDetailComponent } from './pages/user-order/user-order-detail/user-order-detail.component';
import { UserOrderComponent } from './pages/user-order/user-order.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { UserReviewProductHistoryComponent } from './pages/user-review/user-review-product-history/user-review-product-history.component';
import { UserReviewProductPendingComponent } from './pages/user-review/user-review-product-pending/user-review-product-pending.component';
import { UserReviewComponent } from './pages/user-review/user-review.component';
import { UserSkinFitComponent } from './pages/user-skin-fit/user-skin-fit.component';
import { UserWishlistComponent } from './pages/user-wishlist/user-wishlist.component';
import { UserComponent } from './user.component';

const appName = environment.appName;
const routes: Routes = [
  {
    path: '',
    component: UserComponent,
    children: [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full',
      },
      {
        path: 'profile',
        title: 'Profile' + ' | ' + appName,
        component: UserProfileComponent,
      },
      {
        path: 'checkout',
        title: 'Checkout' + ' | ' + appName,
        component: UserCheckoutComponent,
      },
      {
        path: 'invoice/:checkoutId',
        title: 'Invoice' + ' | ' + appName,
        component: UserInvoiceComponent,
      },
      {
        path: 'dashboard',
        title: 'Dashboard' + ' | ' + appName,
        component: UserDashboardComponent,
      },
      {
        path: 'happy-pay',
        title: 'Happy Pay' + ' | ' + appName,
        component: UserHappyPayComponent,
        children: [
          {
            path: '',
            redirectTo: 'transaction',
            pathMatch: 'full',
          },
          {
            path: 'transaction',
            title: 'Transaction' + ' | ' + appName,
            component: UserHappyPayTransactionHistoryComponent,
          },
          {
            path: 'withdrawal',
            title: 'Withdrawal' + ' | ' + appName,
            component: UserHappyPayWithdrawalComponent,
          },
          {
            path: 'top-up',
            title: 'Top up' + ' | ' + appName,
            component: UserHappyPayTopupComponent,
          },
          {
            path: 'bank-account',
            title: 'Bank Account' + ' | ' + appName,
            component: UserHappyPayBankAccountComponent,
          },
        ],
      },
      {
        path: 'order',
        title: 'Order' + ' | ' + appName,
        component: UserOrderComponent,
      },
      {
        path: 'order/:orderId',
        title: 'Order' + ' | ' + appName,
        component: UserOrderDetailComponent,
      },
      {
        path: 'review',
        title: 'Review' + ' | ' + appName,
        component: UserReviewComponent,
        children: [
          {
            path: '',
            redirectTo: 'pending',
            pathMatch: 'full',
          },
          {
            path: 'pending',
            title: 'Pending Review' + ' | ' + appName,
            component: UserReviewProductPendingComponent,
          },
          {
            path: 'history',
            title: 'History' + ' | ' + appName,
            component: UserReviewProductHistoryComponent,
          },
        ],
      },
      {
        path: 'wishlist',
        title: 'Wishlist' + ' | ' + appName,
        component: UserWishlistComponent,
      },
      {
        path: 'beautybook-post',
        title: 'BeautyBook Post' + ' | ' + appName,
        component: UserBeautybookPostComponent,
      },
      {
        path: 'skin-fit',
        title: 'Skin Fit' + ' | ' + appName,
        component: UserSkinFitComponent,
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
